<template>
	<div class="financial-dashboard">
		<div class="cards-container">
			<div
				v-for="module in modules"
				:key="module.type_register_id"
				class="card-wrapper"
			>
				<v-card
					:class="module.color"
					class="white--text module-card"
					elevation="4"
				>
					<v-card-title class="card-title">
						<v-icon medium class="card-icon white--text">
							{{ module.icon }}
						</v-icon>
						<h4 class="text-h6 font-weight-bold">
							{{ module.module_name }}
						</h4>
					</v-card-title>

					<v-card-text class="white--text card-content">
						<!-- Contadores -->
						<div class="counters-section">
							<div class="counter-item">
								<div class="counter-number">
									{{ module.pending_count }}
								</div>
								<div class="counter-label">Pendientes</div>
							</div>
							<div class="counter-item">
								<div class="counter-number">
									{{ module.confirmed_count }}
								</div>
								<div class="counter-label">Confirmados</div>
							</div>
						</div>

						<v-divider class="white--text divider"></v-divider>

						<!-- Totales Pendientes -->
						<div class="totals-section pending-section">
							<div class="section-title">Pendientes:</div>
							<div class="amount-row">
								<span class="amount-label">Debe:</span>
								<span class="amount-value">
									${{ module.pending_total_debe || 0 | formatAmount }}
								</span>
							</div>
							<div class="amount-row">
								<span class="amount-label">Haber:</span>
								<span class="amount-value">
									${{ module.pending_total_haber || 0 | formatAmount }}
								</span>
							</div>
						</div>

						<!-- Totales Confirmados -->
						<div class="totals-section">
							<div class="section-title">Confirmados:</div>
							<div class="amount-row">
								<span class="amount-label">Debe:</span>
								<span class="amount-value">
									${{ module.confirmed_total_debe || 0 | formatAmount }}
								</span>
							</div>
							<div class="amount-row">
								<span class="amount-label">Haber:</span>
								<span class="amount-value">
									${{ module.confirmed_total_haber || 0 | formatAmount }}
								</span>
							</div>
						</div>
					</v-card-text>
				</v-card>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FinancialCards',
	data() {
		return {
		};
	},
	methods: {
	},
	props: {
		modules: {
			type: Array,
			default: () => [],
		},
	},
};
</script>

<style scoped>
.financial-dashboard {
	background-color: #f5f5f5;
	min-height: 100vh;
	padding: 20px;
}

.cards-container {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 20px;
	max-width: 1200px;
	margin: 0 auto;
}

.card-wrapper {
	display: flex;
	flex-direction: column;
}

.module-card {
	height: 310px;
	transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
	cursor: pointer;
	display: flex;
	flex-direction: column;
	border-radius: 12px;
}

.module-card:hover {
	transform: translateY(-4px);
	box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
}

.card-title {
	padding-bottom: 8px !important;
	flex-shrink: 0;
}

.card-icon {
	margin-right: 8px;
}

.card-content {
	padding-top: 0 !important;
	flex: 1;
	display: flex;
	flex-direction: column;
}

.divider {
	margin-bottom: 16px;
}

/* Contadores */
.counters-section {
	display: flex;
	justify-content: space-around;
	margin-bottom: 16px;
}

.counter-item {
	text-align: center;
	flex: 1;
}

.counter-number {
	font-size: 2rem;
	font-weight: bold;
	line-height: 1.2;
}

.counter-label {
	font-size: 0.75rem;
	opacity: 0.9;
	margin-top: 4px;
}

/* Totales */
.totals-section {
	margin-bottom: 12px;
}

.pending-section {
	margin-bottom: 16px;
}

.section-title {
	font-size: 0.875rem;
	font-weight: bold;
	margin-bottom: 8px;
}

.amount-row {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 4px;
}

.amount-label {
	font-size: 0.75rem;
	opacity: 0.9;
}

.amount-value {
	font-size: 0.75rem;
	font-weight: 500;
}

/* Responsive Design */
@media (max-width: 1200px) {
	.cards-container {
		grid-template-columns: repeat(3, 1fr);
	}
}

@media (max-width: 900px) {
	.cards-container {
		grid-template-columns: repeat(2, 1fr);
	}
}

@media (max-width: 600px) {
	.cards-container {
		grid-template-columns: 1fr;
		gap: 16px;
	}

	.financial-dashboard {
		padding: 16px;
	}

	.module-card {
		height: auto;
		min-height: 260px;
	}

	.counter-number {
		font-size: 1.5rem;
	}
}

@media (max-width: 480px) {
	.financial-dashboard {
		padding: 12px;
	}

	.cards-container {
		gap: 12px;
	}

	.counter-number {
		font-size: 1.25rem;
	}

	.amount-value {
		font-size: 0.7rem;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/shared/financial-cards.vue